import { render, staticRenderFns } from "./numberGrow.vue?vue&type=template&id=396a01f9&scoped=true"
import script from "./numberGrow.vue?vue&type=script&lang=js"
export * from "./numberGrow.vue?vue&type=script&lang=js"
import style0 from "./numberGrow.vue?vue&type=style&index=0&id=396a01f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396a01f9",
  null
  
)

export default component.exports